// extracted by mini-css-extract-plugin
module.exports = {"publicPage":"public-page_publicPage__uH5RS"};